import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import Avatar from 'react-avatar';
import "./EditUserProfileForm.scss";

class EditUserProfileForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      contentType: '',
      sort: 1,
      description: ''
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
  }

  render() {
    return (
      <Form className="edit-profile-form" onSubmit={this.onSubmit}>
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="main-content d-flex p-4">
          <Avatar
            className="ml-1 UppyDragDrop"
            name='Owner Name'
            size={80}
            round={true}
          />
          <div className="user-container">
            <div className="field-box d-flex justify-content-between">
              <div>
                <div className="label">USER NAME</div>
                <div className="value">Priya Rajivashi</div>
              </div>
              <Button variant="outline-danger" className="mr-2" size="sm">EDIT</Button>
            </div>
            <div className="field-box d-flex justify-content-between">
              <div>
                <div className="label">USER NAME</div>
                <div className="value">Priya Rajivashi</div>
              </div>
            </div>
            <div className="field-box d-flex justify-content-between">
              <Form.Group controlId="exampleForm.ControlSelect1">
                <Form.Control as="select" size="sm">
                  <option>Admin</option>
                  <option>Regular User</option>
                  <option>Owner</option>
                </Form.Control>
              </Form.Group>
            </div>
            <div className="actions-box">
              <Button variant="outline-danger" className="mr-2" size="sm">CANCEL</Button>
              <Button variant="outline-danger" className="mr-2" size="sm">SAVE SETTINGS</Button>
            </div>
          </div>
        </div>
      </Form>
    )
  }
}

export default EditUserProfileForm;
